import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-empty-basket',
  templateUrl: './icon-empty-basket.component.html',
  styleUrls: ['./icon-empty-basket.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconEmptyBasketComponent {}
